import React from 'react';
import ReactDOM from 'react-dom';

import Header from './components/header/Header';
import Works from './components/content/Works';
import Wrap from './components/Wrap.js';

ReactDOM.render(<Header/>, document.getElementById('header'));
ReactDOM.render(<Works/>, document.getElementById('works'));
// ReactDOM.render(<Wrap/>, document.getElementById('root'));
